// extracted by mini-css-extract-plugin
export default {"container":"styles_container__cU8jY","menuLabel":"styles_menuLabel__XKpY7","icon":"styles_icon__Xn6vP"};